import { z } from 'zod/v3';

// temporarily lives here until a separate package that both
// cotera-api and cotera-sdk can import from

export type ToolSymbolMap = {
  readonly [symbol: string]: {
    readonly toolName: string;
    readonly toolId: string;
  };
};

export const ToolSymbolMapSchema = z.record(
  z.string(),
  z.object({
    toolName: z.string(),
    toolId: z.string(),
  })
);

const _typeCheck: z.ZodType<ToolSymbolMap> = ToolSymbolMapSchema;

export type CompositeUddWriteKey = {
  readonly actorId?: string;
  readonly entityId: string;
  readonly identifier: string;
  readonly key: string;
};

type PartialUddWriteKey = Omit<CompositeUddWriteKey, 'identifier'>;

export const PartialUddWriteKeySchema = z.object({
  actorId: z.string().optional(),
  entityId: z.string(),
  key: z.string(),
});

export const CompositeUddWriteKeySchema = z.object({
  actorId: z.string().optional(),
  entityId: z.string(),
  identifier: z.string(),
  key: z.string(),
});

const _typeCheck2: z.ZodType<PartialUddWriteKey> = PartialUddWriteKeySchema;
const _typeCheck3: z.ZodType<CompositeUddWriteKey> = CompositeUddWriteKeySchema;
